import { Link } from "react-router-dom";
import { topics } from "@/mocks/topics";
import { formatHeat } from "@/components/feature/TopicCard";

const ranking = [...topics].sort((a, b) => b.heat - a.heat).slice(0, 5);
const maxHeat = ranking[0]?.heat || 1;

export default function HotRanking() {
  return (
    <section className="mx-auto w-full max-w-[1280px] px-4 py-14 md:px-6 md:py-16">
      <div className="flex flex-col gap-2 sm:flex-row sm:items-end sm:justify-between">
        <div>
          <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            今日吃瓜热议榜
          </h2>
          <p className="mt-2 text-sm text-foreground-600">
            按热度实时排序，看看今天瓜友都在围观什么。
          </p>
        </div>
        <Link
          to="/topics"
          className="whitespace-nowrap text-sm font-medium text-primary-600 transition-colors hover:text-primary-700"
        >
          查看全部话题 <i className="ri-arrow-right-line"></i>
        </Link>
      </div>

      <ol className="mt-8 flex flex-col divide-y divide-background-200 overflow-hidden rounded-lg border border-background-200 bg-background-50">
        {ranking.map((topic, index) => (
          <li key={topic.id}>
            <Link
              to={`/topic/${topic.id}`}
              className="group flex items-center gap-4 px-4 py-5 transition-colors hover:bg-primary-50/50 md:px-6"
            >
              <span
                className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-md font-heading text-base font-bold ${
                  index === 0
                    ? "bg-accent-500 text-background-50"
                    : index < 3
                      ? "bg-primary-500 text-background-50"
                      : "bg-background-200 text-foreground-700"
                }`}
              >
                {index + 1}
              </span>

              <div className="min-w-0 flex-1">
                <div className="flex flex-wrap items-center gap-2">
                  <span className="rounded-full bg-secondary-100 px-2.5 py-0.5 text-xs font-medium text-secondary-700">
                    {topic.categoryName}
                  </span>
                  <span className="text-xs text-foreground-500">{topic.time}</span>
                </div>
                <h3 className="mt-2 line-clamp-1 font-heading text-base font-semibold text-foreground-950 transition-colors group-hover:text-primary-700 md:text-lg">
                  {topic.title}
                </h3>
                <div className="mt-3 flex items-center gap-3">
                  <div className="h-1.5 w-full max-w-[220px] overflow-hidden rounded-full bg-background-200">
                    <div
                      className="h-full rounded-full bg-gradient-to-r from-primary-400 to-accent-500"
                      style={{ width: `${Math.round((topic.heat / maxHeat) * 100)}%` }}
                    />
                  </div>
                  <span className="whitespace-nowrap text-xs text-foreground-600">
                    {formatHeat(topic.heat)} 热度
                  </span>
                </div>
              </div>

              <span className="hidden shrink-0 items-center gap-1 text-xs text-foreground-600 sm:flex">
                <i className="ri-chat-3-line"></i>
                {topic.comments} 条议论
              </span>
            </Link>
          </li>
        ))}
      </ol>
    </section>
  );
}